import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { FormSection, formValues, propTypes as formPropTypes } from 'redux-form'
import { lpForm } from 'lp-form'
import { SubmitButton } from 'lp-components'
import { GiftContactFields } from '../components'
import { ADDRESS_FORM_VALIDATOR } from 'config'
import { getLocalityFromGooglePlace, formatSubpremise } from 'utils'

const propTypes = {
  autoCompleteAddress: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  country: PropTypes.string,
  fetchPlaceDetails: PropTypes.func.isRequired,
  ...formPropTypes,
}

function GiftBillingForm({
  autoCompleteAddress,
  change,
  country = null,
  fetchPlaceDetails,
  handleSubmit,
  submitting,
}) {
  const updateAddressValues = useCallback(
    async (searchResult) => {
      const googlePlace = await fetchPlaceDetails(searchResult.place_id)
      const {
        streetNumber,
        street,
        city,
        state,
        country: selectedCountry,
        postalCode,
        subpremise,
      } = getLocalityFromGooglePlace(googlePlace)

      if (subpremise) {
        const formattedSubpremise = formatSubpremise(subpremise)
        change(
          'billingContact.address',
          `${streetNumber} ${street}, ${formattedSubpremise}`,
        )
      } else {
        change('billingContact.address', `${streetNumber} ${street}`)
      }
      change('billingContact.city', city)
      change('billingContact.state', state)
      change('billingContact.country', selectedCountry)
      change('billingContact.postalCode', postalCode)
    },
    [change, fetchPlaceDetails],
  )

  return (
    <form onSubmit={handleSubmit} noValidate>
      <div className="group-block">
        <FormSection name="billingContact">
          <GiftContactFields
            {...{
              autoCompleteAddress,
              change,
              country,
              updateAddressValues,
            }}
            usageLabel="Billing"
          />
        </FormSection>
      </div>
      <div className="button-group">
        <SubmitButton {...{ submitting }}>Continue to Payment</SubmitButton>
      </div>
    </form>
  )
}

GiftBillingForm.propTypes = propTypes

export default compose(
  lpForm({
    name: 'GiftBillingForm',
    constraints: {
      ['billingContact.address']: ADDRESS_FORM_VALIDATOR,
      ['billingContact.city']: { presence: { allowEmpty: false } },
      ['billingContact.country']: { presence: { allowEmpty: false } },
      ['billingContact.email']: { email: true, presence: true },
      ['billingContact.firstName']: { presence: { allowEmpty: false } },
      ['billingContact.lastName']: { presence: { allowEmpty: false } },
      ['billingContact.phone']: { presence: { allowEmpty: false } },
      ['billingContact.postalCode']: { presence: { allowEmpty: false } },
      ['billingContact.state']: { presence: { allowEmpty: false } },
    },
  }),
  formValues({
    country: 'billingContact.country',
  }),
)(GiftBillingForm)
